import React from 'react';
import { motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const HeroSection: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const handleNav = (path: string) => {
    navigate({ pathname: path, search: `?lng=${i18n.language}` });
  };

  return (
    <section className="min-h-screen flex items-center justify-center pt-20 bg-gradient-to-b from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark relative overflow-hidden watermark-bg">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial="initial"
          animate="animate"
          variants={{
            animate: {
              transition: {
                staggerChildren: 0.2
              }
            }
          }}
          className="text-center relative z-10"
        >
          {/* Add your animated hero content here */}
          <motion.div
            variants={{
              initial: { opacity: 0, y: 60 },
              animate: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } }
            }}
          >
            <h1 className="text-5xl md:text-7xl font-extrabold mb-6 bg-gradient-to-r from-accent to-emerald-600 bg-clip-text text-transparent leading-tight py-2">
              <Trans>hero.title</Trans>
            </h1>
          </motion.div>
          <motion.div
            variants={{
              initial: { opacity: 0, y: 60 },
              animate: { opacity: 1, y: 0, transition: { duration: 1, ease: 'easeOut' } }
            }}
          >
            <p className="text-xl md:text-2xl mb-6 text-gray-700 dark:text-gray-300">
              <Trans>hero.subtitle</Trans>
            </p>
          </motion.div>
          <motion.div
            variants={{
              initial: { opacity: 0, y: 60 },
              animate: { opacity: 1, y: 0, transition: { duration: 1.1, ease: 'easeOut' } }
            }}
          >
            <button
              onClick={() => handleNav('/imports')}
              className="bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-2xl p-6 mb-8 shadow-xl max-w-4xl mx-auto hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105"
            >
              <div className="text-3xl md:text-4xl font-extrabold">
                <Trans>hero.savingsTitle</Trans>
              </div>
            </button>
          </motion.div>
          <motion.div
            variants={{
              initial: { opacity: 0, y: 60 },
              animate: { opacity: 1, y: 0, transition: { duration: 1.2, ease: 'easeOut' } }
            }}
          >
            <div className="flex flex-col md:flex-row gap-4 justify-center items-center mt-2 w-full max-w-md mx-auto">
              <a
                href="#request"
                className="inline-block bg-accent text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-opacity-90 transition-colors w-full md:w-[260px] whitespace-nowrap flex items-center justify-center text-center"
              >
                <Trans>hero.cta</Trans>
              </a>
              <button
                onClick={() => handleNav('/pricing')}
                className="inline-block bg-accent text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-opacity-90 transition-colors w-full md:w-[260px] whitespace-nowrap flex items-center justify-center text-center"
              >
                <Trans>hero.seeEquipment</Trans>
              </button>
              <button
                onClick={() => handleNav('/imports')}
                className="inline-block bg-accent text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:bg-opacity-90 transition-colors w-full md:w-[260px] whitespace-nowrap flex items-center justify-center text-center"
              >
                <Trans>hero.learnImport</Trans>
              </button>
            </div>
          </motion.div>
        </motion.div>
      </div>
      {/* Decorative elements can be added here if needed */}
    </section>
  );
};

export default HeroSection;
